<template>
  <nav>
    <div>
      <a :class="isUrl('') ? 'active' : ''" href="/">
        Übersicht
      </a>
    </div>
     <div>
      <a  :class="isUrl('events') ? 'active' : ''" href="/events">
          Online Reservationen
      </a>
    </div>
    <!-- <div>
      <a :class="isUrl('cafe') ? 'active' : ''" href="cafe">
        Café Wintower
      </a>
    </div> -->
    <div>
    <a :class="isUrl('visits') ? 'active' : ''" href="visits">
      Besucheranmeldung
    </a>
    </div>
     <div>
      <a :class="isUrl('files') ? 'active' : ''" href="files">
       Dokumente und Pläne
      </a>
    </div>
  </nav>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'

export default {
  components: {
    Icon,
    Link,
  },
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter((url) => currentUrl.startsWith(url)).length
    },
  },
}
</script>
